<script setup lang="ts">
</script>

<template>
    <div class="assignment-footer">
        <div class="assignment-footer__left">
            <slot name="left" />
        </div>
        <div class="assignment-footer__center">
            <slot name="center" />
        </div>
        <div class="assignment-footer__right">
            <slot name="right" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.assignment-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $white;
    box-shadow: 0 -2px 4px 0 rgb(0, 0, 0, 0.1);
    position: fixed;
    z-index: 100;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 57px;

    &__left, &__center, &__right {
        flex: 1;
    }

    &__left {
        text-align: left;
    }

    &__center {
        text-align: center;
    }

    &__right {
        text-align: right;
    }
}
</style>
